import { render, staticRenderFns } from "./AsignacionPage.vue?vue&type=template&id=4b8e8bff"
import script from "./AsignacionPage.js?vue&type=script&lang=js&external"
export * from "./AsignacionPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports